<template>
<div v-if="headerImgUrl" class="header-img-container">
    <!-- Some extension environments like "Popout" or "Video component" have
        variable width. Use a blurry version of the header img to fill
        any empty space on the sides. -->
    <div :style="bgImageStyle" class="bg-image" />
    <img :src="headerImgUrl"/>
</div>
</template>

<script>
export default {
    name: 'HeaderImage',
    props: {
        headerImgUrl: String,
    },
    computed: {
        bgImageStyle: vm => ({ 'background-image': `url(${vm.headerImgUrl})` }),
    },
}
</script>

<style lang="scss" scoped>
.header-img-container {
    @include flex-center-children;
    position: relative;
    overflow: hidden;
}
img {
    z-index: 1;
}
.bg-image {
    position: absolute;
    z-index: 0;
    height: 100%;
    width: 100%;
    filter: blur(20px) brightness(75%);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
